import styled from 'styled-components'

export const OrderTotalDetail = styled.div`
  display: flex;
  justify-content: space-between;
  &:first-child, &:last-child {
    border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool450};
    margin-top: 16px;
    padding-top: 16px;
  },
`

export const OrderTotalGrandTotal = styled(OrderTotalDetail)`
  font-weight: 500;
`
